<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="detallado/caja"></app-filtros-reportes>

            <div style="overflow:auto; height: 85.8vh;">
                <div id="imprimir">
                    <!--Tabla -->
                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Caja</th>
                                <th>Fecha apertura</th>
                                <th>Fecha cierre</th>
                                <th>Provisión inicial</th>
                                <th>Importe de cierre</th>
                                <th>Cajero</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of ctrl.datos; let i=index">
                            <tr>
                                <th>{{ i + 1 }}</th>
                                <th>{{ item.nombre }}</th>
                                <td>{{ item.fecha_apertura | formatoFecha }}</td>
                                <td>{{ item.fecha_cierre | formatoFecha }} </td>
                                <td>{{ item.provision_inicial | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <td>{{ item.importe_cierre | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <td>{{ item.cajero?.nombre }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="6">                                    
                                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                                        <thead>
                                            <tr>
                                                <th>Folio</th>
                                                <th>Código</th>
                                                <th>Fecha</th>
                                                <th>Articulos</th>
                                                <th>Total Art.</th>
                                                <th>Cliente</th>
                                                <th>Subtotal</th>
                                                <th>Descuento</th>
                                                <th>Total</th>
                                                <th>Facturado</th>
                                                <th>Cajero</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let val of item.movimientos; let c=index">
                                            <tr>
                                                <th> {{ val.folio }}</th>
                                                <td>
                                                    <strong>{{val.codigo}} </strong>
                                                </td>
                                                <td>{{ val.created_at | formatoFecha }} </td>
                                                <td>{{ val.total_articulos}}</td>
                                                <td>{{ val.total_contador}}</td>
                                                <td>{{ val.personas?.nombre }}</td>
                                                <td>{{ val.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>{{ val.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>{{ val.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <th>{{ val.facturado > 0 ? 'Si' : 'No'}}</th>
                                                <td>{{ val.usuarios?.nombre }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="ctrl.datos.length == 0">
                                <td colspan="6" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="4" align="right">
                                    <div align="right">Provisión inicial</div>
                                </th>
                                <th colspan="3">
                                    <div align="left">{{ctrl.apertura | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                            <tr>
                                <th colspan="4" align="right">
                                    <div align="right">Importe de cierre</div>
                                </th>
                                <th></th>
                                <th colspan="2">
                                    <div align="left">{{ctrl.cierre | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                        </tfoot>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>